// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PriceDetailsSkeleton-priceDetailsSkeletonBox-aDTcc {
    padding: 24px;
    background: var(--background-primary);
}

.PriceDetailsSkeleton-priceDetailsSkeletonTitle-CsIeg {
    max-width: 161px;
    height: 30px;
    margin-bottom: 12px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountWrapper-ffbVQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    grid-gap: 12px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountWrapper-ffbVQ:not(:first-child) {
    margin-top: 6px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleContainer-ch8C1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    max-width: 60%;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountContainer-pkuvF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    width: 100%;
    max-width: 40%;
}

.PriceDetailsSkeleton-priceDetailsSkeletonDesc-RlTmo {
    height: 24px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountTitle-KwmRR {
    max-width: 95px;
    height: 26px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmount-W540p {
    max-width: 62px;
    height: 26px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleDesc2-aywmL {
    max-width: 102px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleDesc3-xRo02 {
    max-width: 118px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonAmountDesc2-O8N2h,
.PriceDetailsSkeleton-priceDetailsSkeletonAmountDesc3-obTbD {
    max-width: 46px;
}

.PriceDetailsSkeleton-priceDetailsSkeletonDivider-axNdd {
    border-top: 1px solid var(--primary-border);
    margin: 18px 0;
}

.PriceDetailsSkeleton-priceDetailsSkeletonTotalAmountTitle-icgWS {
    max-width: 120px;
    height: 26px;
}

@media (max-width: 767px) {
    .PriceDetailsSkeleton-priceDetailsSkeletonBox-aDTcc {
        padding: 18px;
    }

    .PriceDetailsSkeleton-priceDetailsSkeletonTitle-CsIeg {
        height: 30px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/PriceDetailsSkeleton/PriceDetailsSkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;AAEJ","sourcesContent":[".priceDetailsSkeletonBox {\n    padding: 24px;\n    background: var(--background-primary);\n}\n\n.priceDetailsSkeletonTitle {\n    max-width: 161px;\n    height: 30px;\n    margin-bottom: 12px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.priceDetailsSkeletonAmountWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.priceDetailsSkeletonAmountWrapper:not(:first-child) {\n    margin-top: 6px;\n}\n\n.priceDetailsSkeletonAmountTitleContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    max-width: 60%;\n}\n\n.priceDetailsSkeletonAmountContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    max-width: 40%;\n}\n\n.priceDetailsSkeletonDesc {\n    height: 24px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.priceDetailsSkeletonAmountTitle {\n    max-width: 95px;\n    height: 26px;\n}\n\n.priceDetailsSkeletonAmount {\n    max-width: 62px;\n    height: 26px;\n}\n\n.priceDetailsSkeletonAmountTitleDesc2 {\n    max-width: 102px;\n}\n\n.priceDetailsSkeletonAmountTitleDesc3 {\n    max-width: 118px;\n}\n\n.priceDetailsSkeletonAmountDesc2,\n.priceDetailsSkeletonAmountDesc3 {\n    max-width: 46px;\n}\n\n.priceDetailsSkeletonDivider {\n    border-top: 1px solid var(--primary-border);\n    margin: 18px 0;\n}\n\n.priceDetailsSkeletonTotalAmountTitle {\n    max-width: 120px;\n    height: 26px;\n}\n\n@media (max-width: 767px) {\n    .priceDetailsSkeletonBox {\n        padding: 18px;\n    }\n\n    .priceDetailsSkeletonTitle {\n        height: 30px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priceDetailsSkeletonBox": `PriceDetailsSkeleton-priceDetailsSkeletonBox-aDTcc`,
	"priceDetailsSkeletonTitle": `PriceDetailsSkeleton-priceDetailsSkeletonTitle-CsIeg`,
	"priceDetailsSkeletonAmountWrapper": `PriceDetailsSkeleton-priceDetailsSkeletonAmountWrapper-ffbVQ`,
	"priceDetailsSkeletonAmountTitleContainer": `PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleContainer-ch8C1`,
	"priceDetailsSkeletonAmountContainer": `PriceDetailsSkeleton-priceDetailsSkeletonAmountContainer-pkuvF`,
	"priceDetailsSkeletonDesc": `PriceDetailsSkeleton-priceDetailsSkeletonDesc-RlTmo`,
	"priceDetailsSkeletonAmountTitle": `PriceDetailsSkeleton-priceDetailsSkeletonAmountTitle-KwmRR`,
	"priceDetailsSkeletonAmount": `PriceDetailsSkeleton-priceDetailsSkeletonAmount-W540p`,
	"priceDetailsSkeletonAmountTitleDesc2": `PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleDesc2-aywmL`,
	"priceDetailsSkeletonAmountTitleDesc3": `PriceDetailsSkeleton-priceDetailsSkeletonAmountTitleDesc3-xRo02`,
	"priceDetailsSkeletonAmountDesc2": `PriceDetailsSkeleton-priceDetailsSkeletonAmountDesc2-O8N2h`,
	"priceDetailsSkeletonAmountDesc3": `PriceDetailsSkeleton-priceDetailsSkeletonAmountDesc3-obTbD`,
	"priceDetailsSkeletonDivider": `PriceDetailsSkeleton-priceDetailsSkeletonDivider-axNdd`,
	"priceDetailsSkeletonTotalAmountTitle": `PriceDetailsSkeleton-priceDetailsSkeletonTotalAmountTitle-icgWS`
};
module.exports = ___CSS_LOADER_EXPORT___;
